<script>
  let { title = "", class: className = "", children } = $props();
</script>

<div class="ui-card p-6 {className}">
  {#if title}
    <h3 class="text-lg font-semibold text-white mb-4">{title}</h3>
  {/if}
  {@render children()}
</div>
